import { useEffect, useEffectEvent, useState } from 'react'
import { listCustomers } from '../application/list-customers'
import type { WorkflowCustomer } from '../domain/workflow'
import { customerLookup as customerLookupPort, notify } from '../wiring'

const useCustomerLookup = (enabled: boolean) => {
	const [customers, setCustomers] = useState<WorkflowCustomer[]>([])

	const load = useEffectEvent(async () => {
		const result = await listCustomers(customerLookupPort, null, notify)
		setCustomers(result)
	})

	useEffect(() => {
		if (enabled) load()
	}, [enabled])

	return { customers }
}

export { useCustomerLookup }
